import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faPaperPlane,
  faHeart,
  faMultiply,
  faGift,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faYoutube,
  faTwitter,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import birch from "../img/birch.png";
import map from "../img/address.png";
import beautyLogo from "../img/beautyLogo.png";

const Home = () => {
  const [isShowing, setIsShowing] = useState(false);
  const [path, setPath] = useState("");
  const [Ww, setWw] = useState(window.innerWidth);
  const navRef = useRef();

  const hideModal = () => {
    setIsShowing(false);
  };

  const getImage = (e) => {
    setPath(e.target.src);
    setIsShowing((prev) => !prev);
  };

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  return (
    <>
      {/*-----------------nav section---------------- */}
      <div className="main ">
        <nav ref={navRef}>
          <ul>
            <button className="nav-btn nav-close" onClick={() => showNavbar()}>
              <FontAwesomeIcon icon={faMultiply} />
            </button>
            <li>
              <a href="#w-3">Our work</a>
            </li>
            <li>
              <a href="#">Buy Products</a>
            </li>
            <li>
              <a href="#about">About us</a>
            </li>
            <li>
              <a href="#team">Our Team</a>
            </li>
            <li>
              <a href="#testimonials">Testimonials</a>
            </li>
          </ul>
        </nav>
        <button className="nav-btn nav-show" onClick={() => showNavbar()}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className="beauty fade">
          <img src={beautyLogo} alt="" />
        </div>
        <div className="buttons">
          <button className="header-btn book">BOOK </button>
          <button className="header-btn call">CALL</button>
        </div>
      </div>
      {Ww > 600 ? (
        <div id="scroll-container">
          <div id="scroll-text">
            <h1>
              <FontAwesomeIcon icon={faGift} /> CHECK OUT OUR GIFT CARDS 20%OFF
              LIMITED TIME ONLY <FontAwesomeIcon icon={faGift} />
            </h1>
          </div>
        </div>
      ) : null}
      {/*---------gallery section----------- */}
      <div style={{ margin: "40px auto", width: "30%" }}>
        <hr />
      </div>
      <div className="container ">
        {isShowing && (
          <div
            className="blur"
            style={{ display: "visible", filter: `blur(0px)` }}
          ></div>
        )}
        {isShowing && (
          <div className="modal-container">
            <div onClick={hideModal} className="close-modal">
              <FontAwesomeIcon style={{ fontSize: "40px" }} icon={faMultiply} />
            </div>
            <img src={path} alt="" />
          </div>
        )}
        <div id="w-3" className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_04_06_11_47_12_1288.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_04_06_11_47_03_3391.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_06_24_01_40_46_4210.jpg"
              alt=""
            />
          </div>
        </div>
        <div onClick={getImage} className="gallery-container">
          <div className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/H7rEq_temp_61722199_123083_$2022_12_23_15_44_57_3032.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/FtzpL_temp_61722199_123083_$2022_12_23_15_44_32_0608.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/MKvoF_temp_61722199_123083_$2021_08_27_13_41_09_3162.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_04_06_11_34_24_5946.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_06_24_01_40_46_4210.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container w-4">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/w6zyz_temp_61722199_123083_$2022_12_23_15_44_04_5919.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/FtzpL_temp_61722199_123083_$2022_12_23_15_44_32_0608.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_04_06_11_47_12_1288.jpg"
              alt=""
            />
          </div>
        </div>
        <div className="gallery-container ">
          <div onClick={getImage} className="image">
            <img
              src="https://08af343792081e691a67-4f944f73e7e0823eb9cfb1c9adac8bae.ssl.cf2.rackcdn.com/Original/61722199_123083$2022_04_06_11_47_03_3391.jpg"
              alt=""
            />
          </div>
        </div>
      </div>
      {/*---------------TESTIMONIALS SECTION----------------*/}
      <div
        id="testimonials"
        style={{
          paddingTop: "30px",
          backgroundColor: "#fff",
          fontSize: "39px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        REVIEWS
        <div style={{ margin: "0 auto", width: "30%", paddingBottom: "30px" }}>
          <hr />
        </div>
      </div>
      <div className="main-testimonials-container ">
        <div className="testimonials">
          <div className="review">
            <span>
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
            </span>
            <p>
              "I've been here a few times now and gotten a couple of services.
              The place is always clean and sociable. The stylists know what
              they are doing--you're in good hands here. Pricing is fair. They
              only take cash tips, which is easy to forget."
            </p>
            <h3>- Ashley A </h3>
          </div>
          <div className="review">
            <span>
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
            </span>
            <p>
              "Keli did a wonderful job with my powder brow. She listened to me
              and told me exactly what to expect during the healing process. The
              results are better than I could imagine. I am very satisfied and
              would easily recommend her!"
            </p>
            <h3>- Dorothy F</h3>
          </div>
          <div className="review">
            <span>
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
              <FontAwesomeIcon style={{ color: "#ffa534" }} icon={faStar} />
            </span>
            <p>
              "Birch Beauty Bar has a relaxing atmosphere with an amazing group
              of very skilled women. Jesse did highlights and my daughters hair
              for her wedding. The highlights looked so natural and the perfect
              shade. Her hairstyle for the wedding stayed all day and night. I
              highly recommend checking them out."
            </p>
            <h3>- Gretchen H </h3>
          </div>
        </div>
        <div className="testimonials-btn">
          <button className="write-review">
            <a href="https://www.google.com/search?q=birch+beauty+bar%2C+657+hite+rd%2C+harwick%2C+pa+15049&rlz=1C1UEAD_enUS971US971&oq=birch&aqs=chrome.0.69i59l2j46i67i433j46i67i175i199j0i67i131i433j46i67i199i433i465j0i67l3j0i271.1429j0j15&sourceid=chrome&ie=UTF-8#lrd=0x8834ecc2bdacb6af:0x7d81fb942ec332c8,3,,,,">
              write review
            </a>
          </button>
          <button>
            <a href="https://www.google.com/search?q=birch+beauty+bar%2C+657+hite+rd%2C+harwick%2C+pa+15049&rlz=1C1UEAD_enUS971US971&oq=birch&aqs=chrome.0.69i59l2j46i67i433j46i67i175i199j0i67i131i433j46i67i199i433i465j0i67l3j0i271.1429j0j15&sourceid=chrome&ie=UTF-8#lrd=0x8834ecc2bdacb6af:0x7d81fb942ec332c8,1,,,,">
              more reviews
            </a>
          </button>
        </div>
      </div>
      {/*---------------ABOUT SECTION----------------*/}

      <div id="about" className="about-section">
        <div className="birch">
          <img src={birch} alt="" />
        </div>
        <div style={{ textAlign: "center", paddingTop: "20px" }}>
          <h1>ABOUT US</h1>
        </div>
        <div style={{ margin: "0 auto", width: "30%" }}>
          <hr />
        </div>
        <div className="about-container">
          <p>
            We are an Aveda Concepts Salon offering an array of hair services
            including Customized Aveda Color, Balayage, Ombre, Cezanne Smoothing
            Treatments and more. We also offer Eyelash Extensions, Facial
            Waxing, Airbrush Makeup Lash Lifts, Aveda Facials, Henna Eyebrow
            Design and Eyebrow Microblading!
            <br />
            <br />
            We also offer at the salon or <br /> on location Bridal Services!
            <br />
            <br /> We have a full line of Aveda haircare and skincare on hand
            for you to take home!
          </p>
        </div>
      </div>
      {/*---------------TEAM SECTION----------------*/}
      <div
        style={{
          paddingTop: "30px",
          backgroundColor: "#fff",
          fontSize: "39px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        MEET OUR TEAM
        <div style={{ margin: "0 auto", width: "30%", paddingBottom: "30px" }}>
          <hr />
        </div>
      </div>

      <div id="team" className="our-team-section">
        <div className="card">
          <h3 className="names">Keli Shirey</h3>
          <div className="img">
            <img
              src="https://feb16f6c1af04f371f59-e326581eb23dccb5ba4725805de14ab5.ssl.cf2.rackcdn.com/155x155/61722199_123083_$2020_02_19_15_12_09_8637.JPG"
              alt=""
            />
          </div>
          <p>
            I'm a licensed Esthetician certified in Classic and Volume Eyelash
            Extension, Permanent Eyebrows, Lash Lifts, Henna Eyebrow Sculpting,
            Microdermabrasion, Chemical Peels, Dermaplaning and Facial Waxing. I
            am also a Ololash Certified Eyelash Extensions Educator offering a 2
            day Classic Eyelash Extensions Course!
          </p>
          <button className="team-btn">
            <a href="https://www.vagaro.com/birchbeautybarpgh/book-now">BOOK</a>
          </button>
        </div>
        <div className="card">
          <h3 className="names">Lindsey Patterson</h3>
          <div className="img">
            <img
              src="https://feb16f6c1af04f371f59-e326581eb23dccb5ba4725805de14ab5.ssl.cf2.rackcdn.com/155x155/61722199_123083_$2019_07_12_01_50_31_2852.jpg"
              alt=""
            />
          </div>
          <p>
            I am an Aveda Hair Color Educator, and I specialize in color, cuts
            and Keratherapy Keratin Treatments. I have been a licensed
            cosmetologist for 16 years, and have been with Aveda for 12 years.
          </p>
          <button className="team-btn">
            <a href="https://www.vagaro.com/birchbeautybarpgh/book-now">BOOK</a>
          </button>
        </div>
        <div className="card">
          <h3 className="names">Jessica Costantino</h3>
          <div className="img">
            <img
              src="https://feb16f6c1af04f371f59-e326581eb23dccb5ba4725805de14ab5.ssl.cf2.rackcdn.com/155x155/61722199_123083_$2020_07_03_19_04_53_9888.jpg"
              alt=""
            />
          </div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima
            mollitia architecto eos, sint cupiditate labore assumenda magnam
            quaerat voluptatum neibusdam amet nihil quod modi voluptatibus!
          </p>
          <button className="team-btn">
            <a href="https://www.vagaro.com/birchbeautybarpgh/book-now">BOOK</a>
          </button>
        </div>
        <div className="card">
          <h3 className="names">Jesse Smith</h3>
          <div className="img">
            <img
              src="https://feb16f6c1af04f371f59-e326581eb23dccb5ba4725805de14ab5.ssl.cf2.rackcdn.com/155x155/61722199_123083_$2021_07_21_14_54_46_8144.jpg"
              alt=""
            />
          </div>
          <p>
            Jesse is a licensed Cosmetologist who has been in the industry for
            over 4 years! She specializing in highlights, balayage, tape-in hair
            extensions and cuts!
          </p>
          <button className="team-btn">
            <a href="https://www.vagaro.com/birchbeautybarpgh/book-now">BOOK</a>
          </button>
        </div>
      </div>

      {/*ADDRESS SECTION AND MAP */}

      <div className="address-main">
        <div
          style={{
            paddingTop: "30px",
            fontSize: "39px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          CONTACT INFO
          <div
            style={{ margin: "0 auto", width: "30%", paddingBottom: "30px" }}
          >
            <hr />
          </div>
        </div>
        <div className="address-container">
          <div className="column left">
            <a
              style={{ color: "#fff", fontSize: "22px" }}
              href="https://www.google.com/maps/dir/40.5230438,-79.8632827/birch+beauty+bar,+657+hite+rd,+harwick,+pa+15049/@40.5316914,-79.8758264,13z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x8834ecc2bdacb6af:0x7d81fb942ec332c8!2m2!1d-79.8088753!2d40.5557746"
            >
              {" "}
              <img src={map} alt="" />
              <FontAwesomeIcon icon={faPaperPlane} /> 657 Hite Road, Harwick, PA
              15049
            </a>
          </div>
          <div className="column right">
            <h2>Business hours</h2>
            <p>Monday: 10:00 - 6:00 PM</p>
            <p>Tuesday: 10:00 - 8:00 PM</p>
            <p>Wednsday: 11:00 - 5:00 PM</p>
            <p>Thursday: 10:00 - 7:00 PM</p>
            <p>Friday: 10:30 - 5:00 PM</p>
            <p>Saturday: 10:00 - 3:30PM</p>
            <p>Sunday: Closed</p>
          </div>
        </div>
        <div className="info-grid">
          <div className="col1">
            <div className="info-text">
              <h2>Phone</h2>
              <p>(412 828-3720)</p>
            </div>
            <div className="info-text">
              <h2>Payment Methods Accepted</h2>
              <p>Visa and MasterCard, Discover, Debit card, Cash</p>
            </div>
            <div className="info-text">
              <h2>Amenities</h2>
              <p>Wi-Fi</p>
            </div>
            <div className="info-text">
              <h2>Kids Friendly</h2>
              <p>No Kids</p>
            </div>
          </div>
          <div className="col2">
            <div className="info-text">
              <h2>Spoken Languages</h2>
              <p>English</p>
            </div>
            <div className="info-text">
              <h2>Parking</h2>
              <p>Free Parking</p>
            </div>
            <div className="info-text">
              <h2>Business Type</h2>
              <p>Skin Care, Hair Salon, Lash Bar, Brow Bar, Waxing</p>
            </div>
          </div>
        </div>
        <div style={{ margin: "40px auto", width: "10%" }}>
          <hr />
        </div>
        <div className="social">
          <a href="">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href="">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href="">
            <FontAwesomeIcon icon={faYoutube} />
          </a>
          <a href="">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
        </div>
        <footer>
          <span>
            {" "}
            <a className="link-to-projects" href="https://nikogermano.com/#portfolio">more projects</a>
          </span>{" "}
          <p>
            Birch-app-company &#169; made with{" "}
            <FontAwesomeIcon style={{ color: "crimson" }} icon={faHeart} /> by
            devniko
          </p>
        </footer>
      </div>
    </>
  );
};

export default Home;
